import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../invitation_invite';
import { useQueryClient } from '@tanstack/react-query';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const event = useConnect('event.byId', {
    id: config.params.eventId
  });

  const user = useConnect('user.byId', {
    id: config.params.userId
  });

  if (
    event.state === PayloadStates.FETCHING ||
      user.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      event={event}
      user={user}
      onClose={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['invitation'] });
      }}
    />
  );
};
